// Note: do not use this function other than initializing
export const getWindowSize = () => {
    return {
        width: window.innerWidth,
        height: window.innerHeight
  }
}

const DESKTOPMIN = 1500
const TABLETMIN = 768
const PHONEMIN = 500

export const isDesktop = (windowWidth: number) => windowWidth > DESKTOPMIN
export const isTablet = (windowWidth: number) => windowWidth > TABLETMIN
export const isPhone = (windowWidth: number) => windowWidth > PHONEMIN